<template>
  <div class="index" :style="{'paddingTop': statusBar + 'rem'}">
    <Headerd title="信用保险业务" :back="true" left="首页" :white="true" />
    <div class="indexmain">
      <div class="banner">
        <img src="@/assets/image/del/active1.jpg" alt />
      </div>
      <div class="moreApp">
        <div class="moreIcon backColor" @click="gotoSmall(1)">
          <div class="icon">
            <img class="appIconImg" src="@/assets/image/9.png" alt />
          </div>
          <p>投保咨询</p>
        </div>
        <div class="moreIcon backColor" @click="gotoSmall(2)">
          <div class="icon">
            <img class="appIconImg" src="@/assets/image/10.png" alt />
          </div>
          <p>投保申请</p>
        </div>
        <div class="moreIcon backColor" @click="gotoSmall(3)">
          <div class="icon">
            <img class="appIconImg" src="@/assets/image/10.png" alt />
          </div>
          <p>风险信息</p>
        </div>
      </div>

    </div>
    <div class="tips">
      <div class="tips_out">
        <p class="tips_one">信用保险业务简介</p>
        <p class="tips_tow">投保咨询：</p>
        <p class="tips_last">支持外贸企业通过"单一窗口"向中国信保发起投保信用保险的咨询。企业询保信息将按注册地自动发送到中国信保对应辖区分支机构，以便有针对性地提供咨询服务。</p>
        <p class="tips_tow">投保申请：</p>
        <p class="tips_last">支持全国所有政府平台上的小微企业在"单一窗口"实现全路程在线投保和续转。</p>
        <p class="tips_tow">风险信息：</p>
        <p class="tips_last">支持外贸企业通过"单一窗口"获取中国信保发布的国别/地区、行业等风险预警信息，帮助外贸企业及时了解海外市场咨讯，增强风险意识。</p>
      </div>

    </div>
  </div>
</template>

<script>
import Headerd from "@/components/Headerd";
import { Grid, GridItem, Field } from "vant";
export default {
  name: "topicDetail",
  /**
   * 初始化数据
   */
  data() {
    return {
      statusBar: 0,
      accountType: "",
    };
  },
  /**
   * 初始化
   */
  mounted() {
    this.statusBar = this.$tool.statusBar(45);
    this.getAccountVo();
  },
  /**
   * 方法
   */
  methods: {
    getAccountVo() {
      this.$http
        .post("/masserver/sw/app/auth/getAccountInfo")
        .then((res) => {
          if (res && res.extendAttributes) {
            this.accountType = res.extendAttributes.account_type;
          }
        })
        .catch(() => {
          this.$toast("获取用户信息失败");
        });
    },
    /**
     * 跳转小应用
     */
    gotoSmall(val) {
      if (this.accountType == "2" || this.accountType == "4") {
        this.$toast("该账号没有相应权限，请切换企业账号登录后操作");
        return false;
      }

      if (val === 1) {
        this.$router.push("/eci/apply");
      }
      if (val === 2) {
        this.$router.push("/eci/insure");
      }
      if (val === 3) {
        this.$router.push("/risk");
      }
    },
  },
  components: {
    Headerd,
    [GridItem.name]: GridItem,
    [Grid.name]: Grid,
    [Field.name]: Field,
  },
};
</script>

<style scoped lang="scss">
.index {
  background: #f3f3f3;
  .tips {
    margin: 0px 4px;
    padding-bottom: 1px;
    .tips_out {
      margin: 3px 12px 14px 12px;
      background: #fff;
      border-radius: 4px;
      .tips_one {
        padding: 12px 12px;
        font-size: 15px;
        font-weight: bold;
        //color: #949494;
      }
      .tips_tow {
        // margin-left: 24px;
        // margin-right: 10px;
        padding: 5px 12px;
        font-size: 14px;
        font-weight: bold;
        //color:#949494;
      }
      .tips_last {
        // margin-left: 24px;
        // margin-right: 10px;
        padding: 0px 12px;
        margin-top: 5px;
        margin-bottom: 5px;
        font-size: 14px;
        text-indent: 25px;
        //color:#949494;
        padding-bottom: 10px;
        line-height: 25px;
      }
    }
  }
  .indexmain {
    overflow: hidden;

    .banner {
      width: 100%;
      height: 175px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .moreApp {
      //    background: #fff;
      display: flex;
      margin: 14px 12px 0 12px;
      flex-wrap: wrap;
      padding-bottom: 4px;
      width: 351px;
      .moreIcon {
        width: 109px;
        height: 94px;
        text-align: center;
        background-color: #f0f0f0;
        margin: 4px auto;
        .icon {
          margin: 20px auto 0 auto;
          width: 24px;
          height: 24px;
          text-align: center;
          .appIconImg {
            width: 24px;
            padding-top: 6px;
          }
          .newImg {
            width: 14px;
            padding-left: 5px;
          }
        }
        p {
          margin: 17px auto;
          text-align: center;
          font-size: 12px;
          color: #030f26;
        }
      }
      .backColor {
        background-color: #fff;
      }
    }
  }
}
</style>

